import { createFileRoute } from '@tanstack/react-router'
import { ObserversTable } from '../../../../features/admin/components/observers-table'

export const Route = createFileRoute('/admin/agent/observers/')({
  component: AdminObserversPage,
})

function AdminObserversPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 py-2">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Observers</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Investor follows and what a classifier made of them. What an investor wrote as a condition
          is private to them and never shown here: you see the kind it was read as and whether the
          read worked, which is enough to debug why an alert did or did not arrive.
        </p>
      </div>

      <ObserversTable />
    </div>
  )
}
